module.exports = __webpack_public_path__ + "img/QA.239a10cc.png";